import { render, staticRenderFns } from "./addExpenses.vue?vue&type=template&id=1f71b9d0&scoped=true&"
import script from "./addExpenses.vue?vue&type=script&lang=js&"
export * from "./addExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f71b9d0",
  null
  
)

export default component.exports